import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InvoiceRoutingModule } from "./invoice-routing.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "../shared/shared.module";
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { AgGridModule } from 'ag-grid-angular';

import { ReportService } from "src/app/services/report/report.service";
import { ExcelService } from "src/app/services/excel.service";
import { SalesInvoiceAddComponent } from "src/app/components/invoices/sales/add/add.component";
import { CustomerService } from "src/app/services/customer.service";
import { VendorService } from "src/app/services/vendor.service";
import { ProductService } from "src/app/services/products.service";
import { NetworkService } from "src/app/services/network.service";
import { SalesInvoiceService } from "src/app/services/misc/sales/sales.service";
import { SalesInvoiceListComponent } from "src/app/components/invoices/sales/list/list.component";
import { InvoiceDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/invoice-delete.componet"; 
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { CompanyService } from "src/app/services/company.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { SupplementaryInvoiceListComponent } from "src/app/components/invoices/supplementary/list/list.component";
import { SupplementaryInvoiceAddComponent } from "src/app/components/invoices/supplementary/add/add.component";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { SupplementaryInvoiceService } from "src/app/services/misc/supplementary/supplementary.service";
import { SupplementaryInvoiceUpdateDuesComponent } from "src/app/components/invoices/supplementary/updatedues/updatedues.component";
import { SupplementaryInvoiceViewComponent } from "src/app/components/invoices/supplementary/view/view.component";
import { SalesInvoiceEditComponent } from "src/app/components/invoices/sales/edit/edit.component";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { AWBService } from "src/app/services/operations/awb.service";
import { VendorReconciliationComponent } from "src/app/components/invoices/vendorreco/vendorreco.component";
import { VendorRecoService } from "src/app/services/misc/vendorreco/vendorreco.service";
import { VendorrecoDetailComponent } from "src/app/components/invoices/vendorreco/details/details.component";
import { EditViewDeleteActionsRenderer } from "src/app/components/shared/ag-grid/cell-renderers/delete-view.component";
import { IRNStatusRenderer } from "src/app/components/shared/ag-grid/cell-renderers/IRNStatusRenderer";
import { IRNAdditonalDetailsComponent } from "src/app/components/invoices/supplementary/irnadditonaldetails/irnadditonaldetails.component";
import { MiscService } from "src/app/services/misc/misc.service";
import { TemplateService } from "src/app/services/system-config/template/templates.service";

@NgModule({
    declarations: [
        SalesInvoiceAddComponent,
        SalesInvoiceEditComponent,
        SalesInvoiceListComponent,
        SupplementaryInvoiceAddComponent,
        SupplementaryInvoiceListComponent,
        InvoiceDeleteActionsRenderer,
        IRNStatusRenderer,
        SupplementaryInvoiceUpdateDuesComponent,
        SupplementaryInvoiceViewComponent,
        IRNAdditonalDetailsComponent,
        VendorReconciliationComponent,
        VendorrecoDetailComponent,
        EditViewDeleteActionsRenderer
    ],
    imports: [
        CommonModule,
        InvoiceRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbHighlight,
        NgbNavModule,
        NgbDropdownModule,
        NgbTypeaheadModule,
        NgbPaginationModule,
        NgSelectModule,
        AgGridModule,
        SharedModule,
        NgbAccordionModule,
        NgMultiSelectDropDownModule
    ],
    exports: [
        SalesInvoiceAddComponent,
        SalesInvoiceEditComponent,
        SalesInvoiceListComponent,
        SupplementaryInvoiceAddComponent,
        SupplementaryInvoiceListComponent,
        InvoiceDeleteActionsRenderer,
        SupplementaryInvoiceUpdateDuesComponent,
        SupplementaryInvoiceViewComponent,
        IRNAdditonalDetailsComponent,
        VendorReconciliationComponent,
        VendorrecoDetailComponent,
        EditViewDeleteActionsRenderer
    ],
    providers: [ReportService, ExcelService,CustomerService,VendorService, ProductService, AWBService,MiscService,
        NetworkService, SalesInvoiceService, CompanyService, AddressBookService, ChargesService, SupplementaryInvoiceService, RateUploadService,VendorRecoService, TemplateService]
})

export class InvoiceModule { }